import { ModalContext } from './ModalContext';
import ModalProvider from './ModalProvider';
import { useModalContext } from './useModalContext';
import { ModalTypes } from './consts';

export { useModalContext, ModalTypes, ModalContext };

export type { ModalProps } from './modalsProps';

export default ModalProvider;
